module.exports = __webpack_public_path__ + "static/media/008.93259b04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/008.jpg
// module id = 355
// module chunks = 0